var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0239 0H2.46832C1.23498 0 0.246094 0.988889 0.246094 2.22222V6.66667H2.46832V2.22222H18.0239V17.7778H2.46832V13.3333H0.246094V17.7778C0.246094 18.3671 0.48022 18.9324 0.896967 19.3491C1.31371 19.7659 1.87895 20 2.46832 20H18.0239C18.6132 20 19.1785 19.7659 19.5952 19.3491C20.012 18.9324 20.2461 18.3671 20.2461 17.7778V2.22222C20.2461 1.63285 20.012 1.06762 19.5952 0.650874C19.1785 0.234126 18.6132 0 18.0239 0ZM8.11276 13.9778L9.69054 15.5556L15.2461 10L9.69054 4.44444L8.11276 6.01111L10.9905 8.88889H0.246094V11.1111H10.9905L8.11276 13.9778Z",
    fill: "#5D5D5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4962e462063f8974f86be5c639153ba5.svg";
export { ForwardRef as ReactComponent };